import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=a39ede20&scoped=true&"
import script from "./Rank.vue?vue&type=script&lang=ts&"
export * from "./Rank.vue?vue&type=script&lang=ts&"
import style0 from "./Rank.vue?vue&type=style&index=0&id=a39ede20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39ede20",
  null
  
)

export default component.exports